<style src="./ItemAnalysis.scss" lang="scss" scoped></style>
<template>
  <main class="item-analysis">
    <content-header path="Analise de Item" />

    <section class="form-box row">
      <section class="row">
        <event-filter
          :filters="filters"
          @submit-filter="searchSubmit"
          :isLoading="isLoadingResult"
        />
      </section>
    </section>

    <ul class="list-items">
      <list-items
        v-for="(item, itemIdx) in filteredItems"
        :key="itemIdx"
        :item="item"
        :itemIdx="itemIdx"
      />
    </ul>
    <div class="navigator">
      <button
        type="button"
        class="button-paginator"
        @click="goToPreviousPage"
        v-shortkey="['ctrl', 'arrowleft']"
        @shortkey="goToPreviousPage">
        <icon-left-arrow />
      </button>
      <button
        type="button"
        class="button-paginator"
        @click="goToNextPage"
        v-shortkey="['ctrl', 'arrowright']"
        @shortkey="goToNextPage">
        <icon-right-arrow />
      </button>

    </div>
  </main>
</template>

<script>
import ContentHeader from "@/components/foundation/content-header/ContentHeader";
import ListItems from "./components/list-items/ListItems";
import { IconRightArrow, IconLeftArrow } from '@/components/primitives/icons'

// import ListHeader from './components/list-header/ListHeader'
// import IsClosedTask from '@/components/foundation/is-closed-task/IsClosedTask'

import EventFilter from "./components/event-filter/EventFilter";

export default {
  name: "ItemAnalysis",
  components: {
    ContentHeader,
    ListItems,
    IconRightArrow,
    IconLeftArrow,
    EventFilter
  },
  data() {
    return {
      items: [],
      filteredItems: [],
      currentPage: 0,
      countPerPage: 40,
      filters: {
        startDate: null,
        endDate: null,
        pativo: null,
        lab: null,
        guaranted: ["TRUE", "FALSE"],
        result: ["TRUE", "FALSE"],
        updateRankingDate: null,
        onlyAssociated: false,
        winnerDistributor: null,
        secondDistributor: null,
        thirdDistributor: null
      },
      isLoadingResult: false
    };
  },
  methods: {
    searchSubmit(filters) {
      this.filters.startDate = filters.startDate;
      this.filters.endDate = filters.endDate;
      this.filters.pativo = filters.pativo;
      this.filters.lab = filters.lab;
      this.filters.guaranted = filters.guaranted;
      this.filters.onlyAssociated = filters.onlyAssociated;
      this.filters.updateRankingDate = filters.updateRankingDate;
      this.filters.result = filters.result;
      this.filters.winnerDistributor = filters.winnerDistributor;
      this.filters.secondDistributor = filters.secondDistributor;
      this.filters.thirdDistributor = filters.thirdDistributor;

      this.loadItems();
    },
    formatBoolean(v) {
      if (v.length === 2) {
        return null;
      }
      return v[0] === "TRUE";
    },
    async loadItems() {
      try {
        this.items = null;
        this.filteredItems = null;
        this.isLoadingResult = true;

        const skipPage = this.currentPage * this.countPerPage
        const limitPage = skipPage + this.countPerPage

        const filter = {
          ...this.filters,
          skip: skipPage,
          limit: limitPage
        }

        const { eventItems } = await this.$store.dispatch('Stock/ITEM_HISTORY', filter)

        this.items = Object.freeze(eventItems)
        this.filteredItems = Object.freeze(eventItems)
      } catch (error) {
        this.$toasted.error('Não foi possível efetuar a busca')
      } finally {
        this.isLoadingResult = false;
      }
    },
    goToPreviousPage () {
      if (this.currentPage === 0) return
      this.currentPage -= 1
      this.loadItems()
    },
    goToNextPage () {
      if (this.filteredItems.length < this.countPerPage) return
      this.currentPage += 1
      this.loadItems()
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/view/item-analysis/ItemAnalysis.vue